import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { printCSS } from '@utils/style'

const maxHeight = 80

interface FadeOverlayProps {
  isExpanded: boolean
  hasInvertedColors?: boolean
}

const StyledFadeOverlay = styled.div<FadeOverlayProps>`
  ${({
    isExpanded,
    theme: {
      colors: { staticBlack, fillDefault },
      utils: { opacity },
    },
    hasInvertedColors,
  }) => css`
    position: absolute;
    bottom: 100%;
    left: 0;
    height: ${maxHeight}px;
    width: 100%;
    background: linear-gradient(
      180deg,
      ${opacity(hasInvertedColors ? staticBlack : fillDefault, '00')} 0%,
      ${hasInvertedColors ? staticBlack : fillDefault} 100%
    );

    ${printCSS(css`
      background: unset;
    `)}
    ${isExpanded &&
    css`
      display: none;
    `}
  `}
`

const FadeOverlay: FunctionComponent<FadeOverlayProps> = ({
  isExpanded,
  hasInvertedColors,
}) => (
  <StyledFadeOverlay
    isExpanded={isExpanded}
    hasInvertedColors={hasInvertedColors}
  />
)

export default FadeOverlay
